import HundredBricksAPIError from '../../../../HundredBricksAPIError';
class AnnualPeriodsError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('AnnualPeriodsError', ...args);
    }
}
export default AnnualPeriodsError;
